var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.layout === 'default')?_c('layout',[_c('router-view',{key:_vm.$route.fullPath})],1):_vm._e(),(_vm.layout === 'auth')?_c('auth-layout',[_c('router-view',{key:_vm.$route.fullPath})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }